import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageMeta } from './models/page-meta';
import { TOKEN_PAGE_META_DEFAULT } from './injection-tokens';

interface PageMetaModuleOptions {
    default: Required<PageMeta>;
}

@NgModule({
    imports: [CommonModule],
})
export class PageMetaModule {
    public static forRoot(options: PageMetaModuleOptions): ModuleWithProviders<PageMetaModule> {
        return {
            ngModule: PageMetaModule,
            providers: [
                {
                    provide: TOKEN_PAGE_META_DEFAULT,
                    useValue: options.default,
                },
            ],
        } as ModuleWithProviders<PageMetaModule>;
    }
}
